import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getHeaders } from 'app/utils/handleHeader';
const initialState = {
    IEReportData: null,
    isInitialised: false,
    isIEReportSuccess: false,
    isIEReportPDFSuccess: false,
    isError: false,
    isLoading: false
};
//--------------Asyncthunk for Get Income-Expense Report --------------------------------
export const getIEReportData = createAsyncThunk('getIEReportData', async ({ fromDate, toDate }, { rejectWithValue }) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/report/incomeexpensereport?fromDate=${fromDate}&toDate=${toDate}`, {
            headers: getHeaders()
        });
        return response;
    } catch (error) {
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
//--------------Asyncthunk for Get Income-Expense Report --------------------------------
export const getIEReportPdf = createAsyncThunk('getIEReportPdf', async ({ fromDate, toDate, incomeType, expenseType }, { rejectWithValue }) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/report/incomeexpensereportpdf?fromDate=${fromDate}&toDate=${toDate}&incomeType=${incomeType}&expenseType=${expenseType}`, {
            responseType: 'arraybuffer',
            headers: { 'Accept': 'application/pdf', ...getHeaders() }
        });
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Income_Expense_Report_${fromDate}-${toDate}.pdf`; // Set the desired file name
        a.click();
        window.URL.revokeObjectURL(url);
    } catch (error) {
        if (error.response && error.response.data.message) {
            return rejectWithValue(error.response.data.message);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

const IEReportSlice = createSlice({
    name: 'IEReportSlice',
    initialState,
    reducers: {},
    extraReducers: {
        //--------------Slice action for the Get Income-Expense Report --------------------------------
        [getIEReportData.pending]: (state, action) => {
            state.isLoading = false;
            state.isIEReportSuccess = false;
            state.isError = false;
        },
        [getIEReportData.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isIEReportSuccess = true;
            state.IEReportData = action.payload;
            state.isError = false;
        },
        [getIEReportData.rejected]: (state, action) => {
            state.isLoading = false;
            state.isIEReportSuccess = false;
            state.isError = true;
        },
        //--------------Slice action for the Download Income-Expense Report --------------------------------
        [getIEReportPdf.pending]: (state, action) => {
            state.isLoading = false;
            state.isIEReportPDFSuccess = false;
            state.isError = false;
        },
        [getIEReportPdf.fulfilled]: (state, action) => {
            state.isLoading = false;
            state.isIEReportPDFSuccess = true;
            state.isError = false;
        },
        [getIEReportPdf.rejected]: (state, action) => {
            state.isLoading = false;
            state.isIEReportPDFSuccess = false;
            state.isError = true;
        },
    }
})
export default IEReportSlice.reducer